import Vue from 'vue'

import utils from './utils/commons'     //引入公用js
import DateUtils from './utils/DateUtils'     //引入公用js
import StringUtils from './utils/StringUtils'     //引入公用js
import ImageUtils from './utils/ImageUtils'     //引入公用js

import {
    postJson,
    postImage,
    postFile,
    postData,
    postForm,
    get,
} from "./utils/http";
import test from './utils/test'

Vue.prototype.$utils = utils;
Vue.prototype.$postJson = postJson;
Vue.prototype.$postFile = postFile;
Vue.prototype.$postImage = postImage;
Vue.prototype.$postData = postData;
Vue.prototype.$postForm = postForm;
Vue.prototype.$get = get;
Vue.prototype.$test = test;

const Components = {
    test,
    utils,
    postJson,
    postImage,
    postFile,
    postData,
    postForm,
    get,
    DateUtils,
    StringUtils,
    ImageUtils
}


Object.keys(Components).forEach(name => {
    Vue.component(name, Components[name])
});

export default Components